import { BASE_URL } from "./variables";
import { getAuthHeaders } from "./auth";

const FALLBACK_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjU5NSwiYnVzaW5lc3NJZCI6NzEsIk1lbWJlcklEIjo5MTksInVzZXJuYW1lIjoiYW5rb3RhLmFkbWluIiwiZmlyc3ROYW1lIjoiSm9obiIsImxhc3ROYW1lIjoiRG9lIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.oCgeNmQXN2gsf64gLZ4x70AsUUkY6k9tFZDTf5bGll4';

export const getAuthorizedServices = async (patientId) => {
  try {
    const headers = getAuthHeaders();
    // Also check businessAuthToken (set after business login), falling back to hardcoded token
    if (!headers['Authorization']) {
      const businessToken = localStorage.getItem('businessAuthToken');
      headers['Authorization'] = `Bearer ${businessToken || FALLBACK_TOKEN}`;
    }

    const response = await fetch(`${BASE_URL}/get-authorized-services?patientId=${patientId}`, { headers });

    if (response.status === 404) return { data: [] };
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    return await response.json();
  } catch (error) {
    console.error('Error fetching authorized services:', error);
    return { data: [] };
  }
};
